import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Activity, PenTool, Archive, Users, GitBranch, BarChart2, User } from 'lucide-react';
import Logo from './Logo';

const NAV_ITEMS = [
  { label: 'Pulse',    icon: Activity,   path: '/dashboard' },
  { label: 'Studio',  icon: PenTool,    path: '/studio' },
  { label: 'Vault',   icon: Archive,    path: '/vault' },
  { label: 'Feed',    icon: Users,      path: '/feed' },
  { label: 'Pipeline',icon: GitBranch,  path: '/pipeline' },
  { label: 'Insights',icon: BarChart2,  path: '/insights' },
  { label: 'Profile', icon: User,       path: '/profile' },
];

export default function NavigationDock() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Studio and Vault have their own top-bar navigation — hide dock there on desktop
  const isStudio = location.pathname === '/studio';
  const isVault  = location.pathname === '/vault';
  if (!isMobile && (isStudio || isVault)) return null;
  // On mobile, Studio handles its own tab bar
  if (isMobile && isStudio) return null;

  return (
    <div style={isMobile ? {
      position: 'fixed',
      bottom: 0, left: 0, right: 0,
      background: '#111827',
      borderTop: '1px solid rgba(255,255,255,0.08)',
      boxShadow: '0 -4px 24px rgba(0,0,0,0.4)',
      padding: '6px 0 env(safe-area-inset-bottom, 6px)',
      display: 'flex', alignItems: 'center', justifyContent: 'space-around',
      zIndex: 1000,
      gap: 2,
    } : {
      position: 'fixed',
      bottom: 24, left: '50%',
      transform: 'translateX(-50%)',
      background: '#111827',
      border: '1px solid rgba(255,255,255,0.1)',
      borderRadius: 24,
      boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
      padding: '8px 16px',
      display: 'flex', gap: 4, alignItems: 'center',
      zIndex: 1000,
    }}>
      {!isMobile && (
        <div style={{ padding: '0 8px 0 4px', display: 'flex', alignItems: 'center' }}>
          <Logo size={28} />
        </div>
      )}
      {NAV_ITEMS.map(({ label, icon: Icon, path }) => {
        const isActive = location.pathname === path;
        return (
          <button
            key={label}
            onClick={() => navigate(path)}
            style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2,
              padding: isMobile ? '7px 2px' : '8px 12px',
              borderRadius: isMobile ? 0 : 12,
              border: 'none', cursor: 'pointer',
              background: isActive ? (isMobile ? 'transparent' : 'rgba(249,115,22,0.12)') : 'transparent',
              minWidth: isMobile ? 0 : 52, flex: isMobile ? 1 : undefined, minHeight: 44,
            }}
          >
            <Icon size={isMobile ? 18 : 20} color={isActive ? '#F97316' : '#6B7280'} />
            <span style={{
              fontSize: isMobile ? 8 : 9, fontWeight: 600,
              color: isActive ? '#F97316' : '#6B7280',
              fontFamily: 'Inter, sans-serif',
              whiteSpace: 'nowrap',
            }}>{label}</span>
            {isActive && (
              <div style={{
                width: 4, height: 4, borderRadius: '50%',
                background: '#F97316', marginTop: 1,
              }} />
            )}
          </button>
        );
      })}
    </div>
  );
}
